// CONTRACT ADDRESSES
export const TezosFA2TraderAnonAddress = 'KT1Kbw5BZLW6Ju6XAmPJyjDuSMQKKBQHGzdi';
export const TezosFA2TraderAnonAddressTestnet = 'KT1Lq11zqBKHhpmTgonr68zkNN8WyepyprZh';

export const TezosFA2TraderBigMapID = '289908';
export const TezosFA2TraderBigMapIDTestnet = '173421';

export const tezosToMutez = (tezos: number) : number => {
  return tezos * 1000000;
};

export const mutezToTezos = (mutez: number) : number => {
  return mutez / 1000000;
};
